<template>
  <div class="fixed-top menucontrol-scroll">
    <Banner />
    <CategoryTable />
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import CategoryTable from "./components/CategoryTable.vue";
export default {
  components: {
    Banner,
    CategoryTable,
  },
};
</script>
